import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, HighlightedText } from '@adv-frontend/filters';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- TODO SS-14220 Тут нужно подумать над слоями
import { useAllBadges } from '#entities/badge';
import { trimAndLowerString } from '#shared/lib/string';
import { BADGES_FILTER_TITLE, PRODUCT_FILTER_BADGES_ID } from '../../constants';
import { useFilterTitleByValue } from '../hooks/useFilterTitleByValue';

type BadgesRowData = {
    id: string;
    label: string;
};

export const createBadgesFilter = () => {
    const slug = PRODUCT_FILTER_BADGES_ID;
    const title = BADGES_FILTER_TITLE;

    return createFilterSelectWithSuggest<string, BadgesRowData>({
        id: slug,
        title,
        suggestProps: {
            dataProvider: function Component(props) {
                const searchString = trimAndLowerString(props.queryArg.searchValue);

                const { data } = useAllBadges({});

                const mappedData = useMemo(
                    () =>
                        (data?.items || [])
                            .filter(({ label }) => trimAndLowerString(label).includes(searchString))
                            .map(({ slug, label }) => {
                                return {
                                    id: slug,
                                    label,
                                };
                            }),
                    [data, searchString]
                );

                const dataProvider = useMemo(() => createStaticDataProvider(mappedData), [mappedData]);

                return props.children(dataProvider);
            },
            useTitleByValue: useFilterTitleByValue,
            renderSelectListItem: ({ item, search }) => <HighlightedText text={item.label} search={search} joinParts />,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
};
